import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { TimeFilterField } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import { getGridLabelKey, TTimeHHmm } from "@ryde/shared";

import { IFilterByIdsReportProps } from "./filters-by-ids.report.models";
import { useTableFiltersActionsReports } from "./use-table-filters-actions-reports";

/**
 * Reports wiring for the shared time filter field: reports address a filter by its template key and label it
 * from the report's own translation namespace, where the grid uses a custom field id.
 */
export const FilterTimeReport = ({
  templateKey,
  initialCheckedValues,
}: IFilterByIdsReportProps): ReactElement => {
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const { setValuesToFilter, handleRemoveFilter } =
    useTableFiltersActionsReports();

  const onApply = (time: TTimeHHmm | undefined): void => {
    setValuesToFilter(templateKey, time ? [time] : []);
  };

  const onRemove = (): void => {
    handleRemoveFilter(templateKey);
  };

  return (
    <TimeFilterField
      fieldId={`report-filter-time-${templateKey}`}
      label={t(getGridLabelKey(entity, templateKey))}
      value={initialCheckedValues}
      onApply={onApply}
      onRemove={onRemove}
    />
  );
};
